// extracted by mini-css-extract-plugin
export var errorIcon = "_jv-1";
export var nameLogo = "_jv-0";